import { jsx as t, jsxs as i } from "react/jsx-runtime";
import "react";
var a = (l) => /* @__PURE__ */ i("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...l,
  children: [
    /* @__PURE__ */ t("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ t("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-990 -744)",
      fill: "white"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0H0V20H20V0Z",
      fill: "#0052B4"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0H0V6.66652H20V0Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 13.3335H0V20H20V13.3335Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ t("path", {
      d: "M3.97656 6.08691V10.8676C3.97656 13.587 7.52918 14.4203 7.52918 14.4203C7.52918 14.4203 11.0818 13.587 11.0818 10.8676V6.08691H3.97656Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ t("path", {
      d: "M5.44531 6.92029H9.61195V5.25361L8.77859 5.67029L7.52859 4.42029L6.27859 5.67029L5.44531 5.25361V6.92029Z",
      fill: "#FFDA44"
    }),
    /* @__PURE__ */ t("path", {
      d: "M10.2487 11.5333L7.54035 8.82495L4.83203 11.5333L5.7159 12.4172L7.54035 10.5927L9.36484 12.4172L10.2487 11.5333Z",
      fill: "#FFDA44"
    }),
    /* @__PURE__ */ t("path", {
      d: "M10.2487 9.00358H8.98508C9.05613 8.88093 9.09746 8.73894 9.09746 8.58702C9.09746 8.12671 8.72434 7.75366 8.2641 7.75366C7.94609 7.75366 7.66992 7.93179 7.52945 8.19366C7.38895 7.93183 7.11281 7.75366 6.7948 7.75366C6.33457 7.75366 5.96145 8.12671 5.96145 8.58702C5.96145 8.73894 6.00281 8.88097 6.07383 9.00358H4.83203C4.83203 9.46386 5.23289 9.83694 5.69312 9.83694H5.66539C5.66539 10.2972 6.03848 10.6703 6.49875 10.6703C6.49875 11.0778 6.79141 11.4164 7.17793 11.4888L6.52133 12.9714C6.83598 13.0993 7.17984 13.1703 7.54047 13.1703C7.90109 13.1703 8.24496 13.0992 8.55961 12.9714L7.90301 11.4888C8.28949 11.4164 8.58219 11.0778 8.58219 10.6703C9.04246 10.6703 9.41555 10.2972 9.41555 9.83694H9.38781C9.84785 9.8369 10.2487 9.46382 10.2487 9.00358Z",
      fill: "#F0F0F0"
    })
  ]
});
export {
  a as default
};
